var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs12":""}},[_c('img',{attrs:{"src":_vm.logoPath,"width":"256px"}})]),_c('v-flex',{attrs:{"mt-4":"","xs12":""}},[_c('w-span',{attrs:{"span-class":_vm.spanClass}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }